var _path, _path2, _ellipse, _ellipse2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 99,
    viewBox: "0 0 102 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5917 44.7556C43.9473 37.6889 36.8806 42.4 36.8806 25.9111C36.8806 11.6008 48.4814 0 62.7918 0C77.1021 0 88.7029 11.6008 88.7029 25.9111C88.7029 40.2215 81.928 40.0445 81.6362 44.7556C81.276 50.5721 93.414 47.1111 93.414 68.3112C93.414 91.8667 68.2278 99.8257 46.3029 98.9334C24.0527 98.0278 8.5892 89.4369 1.54726 68.3112C-0.808296 61.2445 -0.808296 47.8091 3.90282 44.7556C7.10451 42.6804 13.9651 41.4693 20.3917 44.7556C25.694 47.4669 31.6181 52.2544 36.8806 49.4667C39.1798 48.2487 40.878 46.8969 41.5917 44.7556Z",
    fill: "#FFDD38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.929 25.0017C102.649 30.3943 87.0093 38.5051 80.1387 35.9429C75.2805 34.1312 71.5883 29.447 75.3497 25.1827C78.4514 21.6663 82.8758 22.3803 87.5921 22.3124C92.4452 22.2425 96.697 21.7661 98.929 25.0017Z",
    fill: "#FF7E1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.04108,
    ry: 6.60297,
    transform: "matrix(-0.911608 0.41106 0.41106 0.911608 69.5433 17.0915)",
    fill: "#030303"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.15499,
    ry: 3.31061,
    transform: "matrix(-0.864155 0.503226 0.503226 0.864155 70.7769 14.9453)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4706 62.6867C55.6162 62.4428 62.9201 54.8061 69.649 59.8781C77.3032 65.6476 70.3801 75.1241 62.7813 80.9425C51.6705 89.45 30.4129 88.0755 24.1507 76.7296C21.116 71.2314 19.2187 65.7677 24.1507 61.2824C29.9967 55.9659 37.733 62.9197 46.4706 62.6867Z",
    fill: "#FCE95F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuck);
export default __webpack_public_path__ + "static/media/duck.5e09204fac26d89b94c9346146d75b3d.svg";
export { ForwardRef as ReactComponent };